import React from 'react';
import AppFooter from './AppFooter';

const NewLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      {/* Main Content Area */}
      <div className="flex-1 pt-4 pb-20 md:pb-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {children}
        </div>
      </div>

      <AppFooter />
    </div>
  );
};

export default NewLayout;
